import React from "react";

/**
 * 
 * @param message the string to display 
 * @param show the boolen to trigger show/hide 
 * @param left number of pixels from the left
 * @param top number of pixels from the top 
 */
function Popover(props) {
  const { message, show, left = 0, top = 0 } = props;
  const placement = {
    left: left,
    top: top,
  };

  return (
    <div className="popover-wrapper">
      <div
        className={
          show ? "popover-content popover-content-show" : "popover-content"
        }
        style={placement}
      >
        <span className="popover-message">{message}</span>
      </div>
    </div>
  );
}

export default Popover;
